import { useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { Radio } from 'cat-ecommerce-alloy';
import cx from 'classnames';
import { replaceTokensInString } from '@app/utils';
import { NOTE_FIELD_MAX_LENGTH } from '../../../constants';
import { getFieldState } from '../../../utils';
import style from '../../../styles.module.scss';

const RadioField = ({ item }) => {
  const { values, setFieldValue } = useFormikContext();
  const characterCount = values[item.id]?.inputValue.length;
  const { inputLabel, id, name, key } = item;
  const [t] = useTranslation();
  const checkedRadiovalue = values[id].radioValue;
  const getFieldValue = fieldName => {
    return `${fieldName}.radioValue`;
  };
  const onChange = event => {
    setFieldValue(getFieldValue(id), event.target.checked);
    const fieldName = getFieldState(event.target.id, name);
    setFieldValue(getFieldValue(fieldName), !event.target.checked);
  };
  return (
    <div className="position-relative">
      <Field
        type="radio"
        as={Radio}
        name={name}
        id={id}
        checked={checkedRadiovalue}
        onChange={onChange}
        label={
          <span className="u-fs--16 text-univers--bold u-color--DarkGray">
            {t(inputLabel)}
          </span>
        }
        className={`w-100 ${style['conflict-resolution__radio']}`}
      />
      <p
        className={cx(
          'position-absolute end-0 u-fs--16 text-univers u-color--MediumGray pt-1',
          style['counter-text']
        )}
      >
        {replaceTokensInString(
          t('CHARACTER_COUNTER_CHARACTER_LIMIT'),
          characterCount,
          NOTE_FIELD_MAX_LENGTH[key]
        )}
      </p>
    </div>
  );
};

RadioField.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    inputLabel: PropTypes.string,
    name: PropTypes.string
  })
};

export default RadioField;
